// packages
import { h } from 'preact';
import { useRef, useState } from 'preact/hooks';

// local
import { createPortal, sumValues } from './utils';

// components
import CandidateRow from './CandidateRow';
import OtherCandidateRow from './OtherCandidateRow';

export default function Result({
  containerId,
  candidates,
  precincts_total,
  precincts_reporting,
  precincts_reporting_pct,
  record_type,
  record,
}) {
  // no need to keep finding this
  const ref = useRef(null);

  // get container once
  function getContainer() {
    if (ref.current === null) {
      ref.current = document.getElementById(containerId);
    }

    return ref.current;
  }

  return createPortal(
    <ResultsTable
      candidates={candidates}
      meta={{
        precincts_total,
        precincts_reporting,
        precincts_reporting_pct,
        record,
      }}
      record_type={record_type}
    />,
    getContainer()
  );
}

function ResultsTable({
  candidates = [],
  meta = {},
  record_type,
  winnerSlug,
  visibleCandidatesCount = 3,
}) {
  const [showAll, setShowAll] = useState(false);

  const onViewableToggle = () => setShowAll(prev => !prev);

  const candidateCount = candidates.length;
  const totalVotes = sumValues(candidates, 'votes');

  return (
    <table class="table table--results">
      <thead>
        <tr>
          <th scope="col" class="contest__header">
            {record_type === 'contest' ? 'Candidate' : 'Support'}
          </th>
          <th scope="col" class="contest__header table-align-right">
            Votes
          </th>
          <th scope="col" class="contest__header table-align-right">
            Pct.<span class="candidate__pct-symbol">%</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {candidates.map((candidate, idx) => (
          <CandidateRow
            key={`${candidate.slug}-${meta.record}`}
            candidate={candidate}
            isViewable={showAll || idx < visibleCandidatesCount + 1}
          />
        ))}
        {candidateCount > visibleCandidatesCount && (
          <OtherCandidateRow
            isViewable={!showAll}
            votes={sumValues(
              candidates.slice(visibleCandidatesCount + 1),
              'votes'
            )}
            totalVotes={totalVotes}
            candidateCount={candidateCount - visibleCandidatesCount - 1}
            onClick={onViewableToggle}
          />
        )}
      </tbody>
      <tfoot class="results-footer">
        <tr>
          <td>
            {candidateCount > visibleCandidatesCount + 1 && showAll && (
              <button
                class="contest__candidates-toggle"
                onClick={onViewableToggle}
              >
                View fewer candidates <i class="icon LATTriangleUp" />
              </button>
            )}
          </td>
          <td colspan="3">{`${
            meta.precincts_reporting_pct
          }% precincts reporting (${meta.precincts_reporting} of ${
            meta.precincts_total
          })`}</td>
        </tr>
      </tfoot>
    </table>
  );
}
